// Debounce function for performance optimization
function debounce(func, delay = 150) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }
  
  // Create Note element with tracking attribute
  function createNoteElement(capacity) {
    const noteDiv = document.createElement("div");
    noteDiv.className = "restock-rocket-preorder-description";
    noteDiv.style.cssText = "background-color: #ebebeb; border-radius: 10px; margin-top: 10px; padding: 15px;";
    noteDiv.dataset.restockNote = "true";
  
    const textDiv = document.createElement("div");
    textDiv.className = "preorder-description-text";
    textDiv.style.cssText = "color: #000; font-size: 14px; line-height: 1.4;";
    textDiv.textContent = capacity === "20000mAh" 
      ? "Note: The 20,000mAh F11 version will be available for the US market on March 15, 2025."
      : "Note: The 30,000mAh F11 version will be available for the US market on April 10, 2025.";
  
    noteDiv.appendChild(textDiv);
    return noteDiv;
  }
  
  // Cached element getters
  const getCurrentCapacity = () => {
    const input = document.querySelector('quick-view input[name="Capacity"]:checked');
    return input ? input.value : null;
  };
  
  // Main UI update controller
  let isUpdating = false;
  const updateUIState = debounce(() => {
    if (isUpdating) return;
    isUpdating = true;
  
    const quickView = document.querySelector("quick-view");
    if (!quickView) {
      isUpdating = false;
      return;
    }
  
    try {
      const inventorySpan = quickView.querySelector(".product__inventory span");
      const isPreOrder = inventorySpan?.textContent.trim() === "Pre-Order Version";
      
      // Button state management
      const btnText = quickView.querySelector(".buy-buttons .btn-text");
      const paymentButton = quickView.querySelector(".shopify-payment-button");
      
      if (btnText) btnText.textContent = isPreOrder ? "Pre-Order" : "Add to cart";
      if (paymentButton) paymentButton.style.display = isPreOrder ? "none" : "block";
  
      // Note element management
      const existingNote = quickView.querySelector("[data-restock-note]");
      const buyButton = quickView.querySelector(".buy-buttons");
      
      if (isPreOrder) {
        const currentCapacity = getCurrentCapacity();
        if (currentCapacity) {
          const newNote = createNoteElement(currentCapacity);
          if (!existingNote || existingNote.textContent !== newNote.textContent) {
            existingNote?.remove();
            buyButton?.insertAdjacentElement("afterend", newNote);
          }
        }
      } else {
        existingNote?.remove();
      }
    } catch (e) {
      console.error("UI update error:", e);
    } finally {
      isUpdating = false;
    }
  }, 50);
  
  // Optimized event delegation
  const handleCapacityChange = (() => {
    const handler = debounce((e) => {
      if (e.target.matches('input[name="Capacity"]')) {
        updateUIState();
      }
    }, 50);
  
    return () => {
      document.addEventListener("change", handler);
    };
  })();
  
  // Enhanced observer system with WeakMap
  const observerCache = new WeakMap();
  const createStableObserver = (targetSelector, callback) => {
    const debouncedCallback = debounce(callback);
    const observer = new MutationObserver((mutations) => {
      const hasNoteMutation = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
          node.dataset?.restockNote === 'true'
        )
      );
      if (!hasNoteMutation) debouncedCallback();
    });
  
    const connect = () => {
      const target = document.querySelector(targetSelector);
      if (target && !observerCache.has(target)) {
        observer.observe(target, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class"]
        });
        observerCache.set(target, observer);
        return true;
      }
      return false;
    };
  
    if (!connect()) {
      const backupObserver = new MutationObserver(() => {
        if (connect()) backupObserver.disconnect();
      });
      backupObserver.observe(document.body, { childList: true, subtree: true });
    }
  };
  
  // Initialization system
  let isObserving = false;
  const initSafeObservers = () => {
    if (isObserving) return;
    isObserving = true;
  
    createStableObserver("quick-view", () => {
      handleCapacityChange();
      updateUIState();
    });
  
    createStableObserver("quick-view .product__inventory", updateUIState);
  };
  
  // Safe startup sequence
  const safeInit = debounce(() => {
    const quickView = document.querySelector("quick-view");
    if (quickView) {
      initSafeObservers();
      updateUIState();
    } else {
      const tempObserver = new MutationObserver((_, observer) => {
        if (document.querySelector("quick-view")) {
          safeInit();
          observer.disconnect();
        }
      });
      tempObserver.observe(document.body, { childList: true, subtree: true });
    }
  }, 100);
  
  // Event listeners
  document.addEventListener('DOMContentLoaded', safeInit);
  window.addEventListener('load', safeInit);